import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoaderService } from '../services/loader.service';

const BLOCKING_METHODS = ['POST', 'PUT', 'PATCH', 'DELETE'];

function isOwnApiRequest(request: HttpRequest<unknown>): boolean {
  try {
    return (
      new URL(request.url, document.baseURI).origin ===
      new URL(environment.apiURl).origin
    );
  } catch {
    return false;
  }
}

export const globalLoaderInterceptor: HttpInterceptorFn = (request, next) => {
  if (
    !BLOCKING_METHODS.includes(request.method) ||
    request.url.includes('/auth/') ||
    !isOwnApiRequest(request)
  ) {
    return next(request);
  }

  const loader = inject(LoaderService);
  loader.begin();

  return next(request).pipe(finalize(() => loader.end()));
};
